import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import IllustrationBadge from '@deliveroo/consumer-component-library/components/IllustrationBadge';
import styles from './styles.scss';

const FetchErrorContent = ({ heading, message }) => (
  <div className={styles.error}>
    <IllustrationBadge name="desktop-error" size={120} />
    <Heading size="x-small" level={4} spacing="large 0 small">
      {heading}
    </Heading>
    <P color="grey">{message}</P>
  </div>
);

FetchErrorContent.propTypes = {
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default FetchErrorContent;
